import React, { Component } from "react";
import MainLayout from "../../components/layouts/MainLayout";
import { withRouter } from "../../hoc/withRouter";
import { Tooltip, Table, Form, message, Col, Button, Modal, Input } from "antd";
import { settingOtodisApiService } from "../../services/otodis/SettingOtodisApiService";
import { CopyOutlined, PlusSquareOutlined } from "@ant-design/icons";
import { SettingDeliveryVehicleStates } from "./types/SettingDeliveryVehicleTypes";
import withAuth from "../../hoc/withAuth";
import Cookies from "universal-cookie";

export interface SettingDeliveryVehicleProps {}

class SettingDeliveryVehicle extends Component<SettingDeliveryVehicleProps & any, SettingDeliveryVehicleStates> {
  private readonly initState!: SettingDeliveryVehicleStates;
  private token = new Cookies().get("_t");

  constructor(props: (SettingDeliveryVehicleProps & any) | any) {
    super(props);

    this.initState = {
      token: this.token,
      processing: false,
      processingFetchTableData: true,
      dealerCode: props.match.params.dealerCode.replace(/-/g, "#"),
      dataSettingDeliveryVehicle: [],
      pageSize: 500,
      modalAddSettingDeliveryVehicle: false,
      addProcessing: false,
      vehicleLicensePlate: "",
      vehicleName: "",
    };
    this.state = { ...this.initState };
  }

  copyToClipboard = async (data: any) => {
    await navigator.clipboard.writeText(data);
  };

  onDealerChange = async (data: any) => {
    await this.promisedSetState({
      processingFetchTableData: true,
      dealerCode: data.value,
    });

    await this.fetchDeliveryVehicleData();
  };

  fetchDeliveryVehicleData = async () => {
    await settingOtodisApiService.setToken(this.token);
    await settingOtodisApiService
      .getDeliveryVehicle({
        dealerCode: this.state.dealerCode,
        active: true,
      })
      .then((dataFetchSettingDeliveryVehicle) => {
        this.setState({
          dealerCode: this.state.dealerCode,
          dataSettingDeliveryVehicle: dataFetchSettingDeliveryVehicle.data.data,
          processingFetchTableData: false,
        });
      })
      .catch(async (reason) => {
        await this.promisedSetState({
          dataSettingDeliveryVehicle: [],
          processingFetchTableData: false,
        });
        message.error("Data Tidak Ditemukan");
      });
  };

  onChangeTable = (pagination: any, filters: any, sorter: any) => {
    if (pagination?.pageSize) {
      this.setState({
        pageSize: pagination?.pageSize,
      });
    }
  };

  onStringFieldChange = <T extends keyof Pick<any, "vehicleLicensePlate" | "vehicleName">>(target: T, value: any) => {
    const currentState: any = { ...this.state };
    switch (target) {
      case "vehicleLicensePlate":
        currentState.vehicleLicensePlate = value?.toUpperCase();
        break;
      case "vehicleName":
        currentState.vehicleName = value?.toUpperCase();
        break;
    }

    this.setState({
      ...currentState,
    });
  };

  okModalSettingDeliveryVehicle = async () => {
    if (!this.state.dealerCode || !this.state.vehicleLicensePlate || !this.state.vehicleName) {
      Modal.error({
        title: "Proses Gagal",
        content: "Mohon Lengkapi Data",
      });
      return;
    }

    await this.promisedSetState({
      addProcessing: true,
    });

    const input = [];
    input.push({
      dealer_code: this.state.dealerCode,
      vehicle_license_plate: this.state.vehicleLicensePlate?.toUpperCase(),
      vehicle_name: this.state.vehicleName?.toUpperCase(),
    });

    try {
      await settingOtodisApiService.setToken(this.token);
      await settingOtodisApiService.createNewDeliveryVehicle(input).then(async (successData) => {
        Modal.success({
          title: "Proses Sukses",
          content: "Data berhasil ditambahkan ",
        });
        this.setState({
          addProcessing: false,
          modalAddSettingDeliveryVehicle: false,
        });

        await this.fetchDeliveryVehicleData();
      });
    } catch (e) {
      Modal.error({
        title: "Proses Gagal",
        content: "Server Menolak Inputan Anda :" + e,
      });
      await this.promisedSetState({
        addProcessing: false,
      });
    }
  };

  async componentDidMount() {
    await this.fetchDeliveryVehicleData();
  }

  promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

  render() {
    return (
      <React.Fragment>
        <MainLayout
          noPadNoMar={true}
          onChangeDealer={this.onDealerChange}
          breadcrumbPath={`Setting`}
          breadcrumbMenu={`DeliveryVehicle`}
          defaultSelectedKeys={["m-setting-delivery-vehicle"]}
          defaultOpenKeys={["sm-setting", "sm-sm-delivery"]}
        >
          <Col span={24} className={`pad-10`}>
            <Form.Item>
              <Button
                type={"primary"}
                icon={<PlusSquareOutlined />}
                onClick={() => {
                  this.setState({ vehicleLicensePlate: "", vehicleName: "", modalAddSettingDeliveryVehicle: true });
                }}
              >
                Tambah Data
              </Button>
            </Form.Item>
          </Col>

          <Table
            rowKey={"driver_id_card"}
            size={"small"}
            scroll={{ x: "calc(500px + 50%)" }}
            loading={this.state.processingFetchTableData}
            columns={[
              {
                title: "Plat Nomor Kendaraan",
                dataIndex: "vehicle_license_plate",
                render: (value: string, row: []) => {
                  return (
                    <React.Fragment>
                      <span className={`font-90`}>{value}</span>
                      &nbsp; &nbsp;
                      <Tooltip title="Click untuk copy Plat Nomor Kendaraan" color={"cyan"}>
                        <CopyOutlined className={"small-avatar-link"} onClick={(event) => this.copyToClipboard(value)} />
                      </Tooltip>
                    </React.Fragment>
                  );
                },
              },
              {
                title: "Nama Kendaraan",
                dataIndex: "vehicle_name",
                render: (value: string) => {
                  return <span className={`font-90`}>{value}</span>;
                },
              },
              {
                title: "Kode Dealer",
                dataIndex: "dealer_code",
                render: (value: string, row: any) => {
                  return <span className={`font-90`}>{value}</span>;
                },
              },
            ]}
            dataSource={this.state.dataSettingDeliveryVehicle}
            pagination={{ pageSize: this.state.pageSize }}
            onChange={this.onChangeTable}
          />

          <Modal
            open={this.state.modalAddSettingDeliveryVehicle}
            title="Tambah Kendaraan Delivery"
            onOk={() => {
              this.setState({ modalAddSettingDeliveryVehicle: false });
            }}
            onCancel={() => {
              this.setState({ modalAddSettingDeliveryVehicle: false });
            }}
            cancelText={"Tutup"}
            okText={false}
            footer={[
              <Button key="1" type="primary" loading={this.state.addProcessing} onClick={this.okModalSettingDeliveryVehicle}>
                Simpan
              </Button>,
              <Button
                key="2"
                type="primary"
                loading={this.state.addProcessing}
                onClick={() => {
                  this.setState({ modalAddSettingDeliveryVehicle: false });
                }}
              >
                Cancel
              </Button>,
            ]}
          >
            <Form layout={"vertical"}>
              <Form.Item>
                <i className={`text-small-grey-nopadding`}>Dealer Code *</i>
                <Input value={this.state.dealerCode} disabled={true} />
              </Form.Item>
              <Form.Item>
                <i className={`text-small-grey-nopadding`}>Nomor Polisi Kendaraan Delivery *</i>
                <Input value={this.state.vehicleLicensePlate} onChange={(event) => this.onStringFieldChange("vehicleLicensePlate", event.target.value)} placeholder="Nama Kendaraan Delivery" />
              </Form.Item>
              <Form.Item>
                <i className={`text-small-grey-nopadding`}>Nama Kendaraan Delivery *</i>
                <Input value={this.state.vehicleName} placeholder="Nama Kendaraan Delivery" onChange={(event) => this.onStringFieldChange("vehicleName", event.target.value)} />
              </Form.Item>
            </Form>
          </Modal>
        </MainLayout>
      </React.Fragment>
    );
  }
}

export default withAuth(withRouter(SettingDeliveryVehicle), 55);
